Librarian.PermissionWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["save"],

    options: {
        id: "PermissionWindow",
        width: 625,
        height: 580,
        itemData: null
    },

    content: null, 
    grid: null,
    checkedUsers: {},
    filter: null,
    
    initialize: function (options) {
        this.setOptions(options);

        if (!this.options.itemData)
            throw "Missing data";

        this.content = Librarian.Utils.getStandardContent(this.options.itemData);

        if (!this.content.contentid || !this.content.contenttype)
            throw "Invalid data";

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("permission_edit");
        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/permission.html";

        this.parent(this.options);
    },

    onWindowLoaded: function () {
        this.parent();
        this.setupElements();

        var itemEl = this.getElement("filterButton");
        if (itemEl) {
            itemEl.addOnClick(function() {
                itemEl = this.getElement("filterBox");
                if (itemEl) {
                    this.filter = itemEl.value;
                    this.reloadGrid();
                }
            }.bind(this));
        }

        itemEl = this.getElement("okButton");
        if (itemEl)
            itemEl.addOnClick(this.save);

        itemEl = this.getElement("closeButton");
        if (itemEl)
            itemEl.addOnClick(this.close);

        var self = this,
            filterEls = $$("a.filterLetter");

        for (var i = 0; i < filterEls.length; i++) {
            filterEls[i].addOnClick(function() {
                var term = this.get("text");
                if (term == "All")
                    self.filter = '';
                else
                    self.filter = term + '%';

                self.reloadGrid();
            });
        }

        this.getPermissions();
    },

    getPermissions: function () {
        var url = Librarian.path.getMethodUrl("getcp") + "&out=cjson&cntid=" + this.content.contentid + "&cnttype=" + this.content.contenttype;

        new Librarian.Request.JSON({
            url: url,
            onSuccess: function (json) {
                if (!json)
                    return;

                json.forEach(function (user) {
                    this.checkedUsers[user.entityId] = user.permissions;
                }.bind(this));

                this.loadGrid();
            }.bind(this)
        }).send();
    },

    loadGrid: function () {
        var itemEl = this.getElement("userGrid");
        if (itemEl) {
            var cmu =
            [
                {
                    header: Librarian.Lang.getString("read"),
                    id: "read",
                    dataType: "checkbox",
                    width: 40,
                    onChange: true,
                    customCheckValue: function (row) {
                        return this.getRowPermission(row) >= 4;
                    }.bind(this)
                },
                {
                    header: Librarian.Lang.getString("write"),
                    id: "write",
                    dataType: "checkbox",
                    width: 40,
                    onChange: true,
                    customCheckValue: function (row) {
                        return this.getRowPermission(row) >= 6;
                    }.bind(this)
                },
                {
                    header: Librarian.Lang.getString("name"),
                    labelFunction: Librarian.Utils.renderContactName,
                    className: Librarian.Utils.getContactNameClass,
                    dataIndex: "lastname",
                    dataType: "string",
                    width: 225
                },
                {
                    header: Librarian.Lang.getString("email"),
                    dataIndex: "email",
                    dataType: "string",
                    width: 350
                }
            ];

            this.grid = new omniGrid(itemEl.id, {
                columnModel: cmu,
                url: this.getUrl(),
                resizable: false,
                pagination: true,
                serverSort: false,
                sortHeader: true,
                perPage: 20,
                width: 600,
                height: 480
            });

            this.grid.onSelect = function (obj) {
                var columnModel = obj.columnModel,
                    checkbox = obj.input,
                    li = this.grid.getLiParent(checkbox),
                    data = this.grid.getDataByRow(obj.row);

                if (!li || !data)
                    return;

                var checkboxes = li.getElements("[type=checkbox]"),
                    readBox = checkboxes[0],
                    writeBox = checkboxes[1];

                if (columnModel.id == "read" && !checkbox.checked && writeBox)
                    writeBox.checked = false;
                else if (columnModel.id == "write" && checkbox.checked && readBox)
                    readBox.checked = true;

                var permission = 0;
                if (writeBox && writeBox.checked)
                    permission = 6;
                else if (readBox && readBox.checked)
                    permission = 4;

                if (permission > 0)
                    this.checkedUsers[data.userid] = permission;
                else
                    delete this.checkedUsers[data.userid];
            }.bind(this);
        }
    },

    getRowPermission: function (row) {
        var data = this.grid.getDataByRow(row);
        if (data)
            return this.checkedUsers[data.userid];

        return 0;
    },

    save: function () {
        var permissions = [];
        Object.forEach(this.checkedUsers, function (value, key) {
            permissions.push({
                entityId: key,
                permissions: value
            });
        });

        var buttonEl = this.getElement("okButton");
        Librarian.Utils.setButtonDisabled(buttonEl, true);

        var url = Librarian.path.getMethodUrl("setcp") + "&in=json&out=ujson&cntid=" + this.content.contentid + "&cnttype=" + this.content.contenttype;

        new Librarian.Request.JSON({
            url: url,
            method: "post",
            data: Base64.encode(JSON.stringify(permissions)),
            onSuccess: function () {
                Librarian.Utils.notification(Librarian.Lang.getString("permission_saved"));

                this.close();
            }.bind(this),
            onFailure: function(error) {
                Librarian.Utils.onFailure(error);
                Librarian.Utils.setButtonDisabled(buttonEl, false);
            }
        }).send();
    },

    reloadGrid: function() {
        this.grid.removeAll();
        this.grid.options.url = this.getUrl();
        // Resets page and refreshes
        this.grid.perPageChange();
    },

    getUrl: function() {
        var url = Librarian.path.getMethodUrl("getusers") + "&out=dgrid&all=1";

        if (this.filter)
            url += "&name=" + this.filter;

        return url;
    }
});